import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';
import DesignerTextField from './DesignerTextField';

import wordCupLogo from './Images/WC-logo.png';
import googleIcon from './Images/GoogleIcon.svg';

import { checkForCode, androidBackButton } from './Utils';

class Login extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;

    this.state = {
      userEmail: '',
      userPassword: '',
    };
  }

  componentDidMount() {
    androidBackButton(this.handleGoBackRoom);
  }

  handleGoBackRoom = () => {
    this.props.navigate(`/`);
  };

  handlePasswordInput = (event) => {
    this.setState({ userPassword: event.target.value });
  };

  handleEmailInput = (event) => {
    this.setState({ userEmail: event.target.value });
  };

  areAllInputsFilled = () => {
    let MissingInput = false;

    if (this.state.userEmail === '' || this.state.userPassword === '') {
      MissingInput = true;
    }

    return MissingInput;
  };

  handleSelectChange = (categoryName, event) => {
    this.setState({ [categoryName]: event.target.value });
  };

  handleSignIn = async () => {
    // there is no such API in the backend , i must write one

    let body = JSON.stringify({
      login: this.state.userEmail,
      password: this.state.userPassword,
    });

    let data = await checkForCode('POST', `/api/users/login`, this.props, body);

    this.props.navigate(`/`, {
      state: {
        roomID: data.roomID,
      },
    });
  };

  render() {
    return (
      <div className="Home">
        <img
          style={{ marginTop: '-40px', marginBottom: '70px' }}
          className="wordCupLogoImg"
          src={wordCupLogo}
          alt="word Cup Logo"
        />

        <div className="wordsArrayOuterDiv">
          <label className="wordsArrayLabel">{'Email Address'}</label>
          <DesignerTextField
            type="email"
            style={{ width: '90%' }}
            value={this.state.userEmail}
            onChange={(event) => {
              this.handleEmailInput(event);
            }}
            onBlur={this.areAllInputsFilled}
            onfocus={this.areAllInputsFilled}
            placeholder={'Enter your Email'}></DesignerTextField>
        </div>

        <div className="wordsArrayOuterDiv">
          <label className="wordsArrayLabel">{'Password'}</label>
          <DesignerTextField
            type="password"
            style={{ width: '90%' }}
            value={this.state.userPassword}
            onChange={(event) => {
              this.handlePasswordInput(event);
            }}
            onBlur={this.areAllInputsFilled}
            onfocus={this.areAllInputsFilled}
            placeholder={'Enter your Password'}></DesignerTextField>
        </div>

        <a className="forgotPasswordText" href="./ForgotPassword">
          Forgot password
        </a>

        <div className="readyToPlayOuterDiv" style={{ height: '125px' }}>
          <div className="readyToPlayInnerDiv" style={{ paddingTop: '0px' }}>
            <DesignerButton
              class="filledButton"
              disabled={this.areAllInputsFilled()}
              onClick={this.handleSignIn}
              buttonText="Sign In"></DesignerButton>
          </div>
        </div>

        <button
          class="googleLoginButton"
          //disabled={this.areAllInputsFilled()}
          onClick={this.handleSignIn}
          type="button">
          <img
            className="googleButtonIcon"
            src={googleIcon}
            alt="Google Icon"></img>
          <p style={{ marginLeft: '10px' }}>Sign In With Google</p>
        </button>

        <label className="signUpLabel">
          Don’t have an account?{' '}
          <a
            href="./SignUp"
            style={{
              textDecoration: 'none',
              color: '#85A0FF',
              fontWeight: 'bolder',
            }}>
            {' '}
            Sign up
          </a>
        </label>
      </div>
    );
  }
}

export default withCookies(Login);
